import { render, staticRenderFns } from "./BranchTransferDetail.vue?vue&type=template&id=1e8d4dfb&"
import script from "./BranchTransferDetail.vue?vue&type=script&lang=js&"
export * from "./BranchTransferDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports